<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  import {Indicator} from 'mint-ui'
  import api from './axios/api'

  export default {
    name: 'app',
    watch: {
      $route (to, from) {
        this.setConfig()
      },
      deep: true
    },
    methods: {
      setConfig () {
        this.$Axios.get(api.weChat, {url: document.URL.split('#')[0]}).then(res => {
          let wxdata = res.data
          wx.config({
            debug: false,
            appId: wxdata.appId,
            timestamp: wxdata.timestamp,
            nonceStr: wxdata.nonceStr,
            signature: wxdata.signature,
            jsApiList: [
              'scanQRCode',
              'chooseImage',
              'uploadImage',
              'getLocalImgData',
              'downloadImage',
              'checkJsApi',
              'openLocation',
              'getLocation',
              'closeWindow',
              'hideMenuItems'
            ]
          })
          wx.ready(() => {
            wx.hideMenuItems({
              menuList: [
                'menuItem:share:appMessage',
                'menuItem:share:timeline',
                'menuItem:share:qq',
                'menuItem:favorite'
              ]
            })
            wx.getLocation({
              type: 'wgs84',
              success: res => {
                let longitude = res.longitude
                let latitude = res.latitude
                this.$store.commit('getlongitude', longitude)
                this.$store.commit('getlatitude', latitude)
                this.$store.commit('setRefuseAddr', '1')
                this.getProvince(longitude + ',' + latitude)
              },
              cancel: res => {
                this.$store.commit('setRefuseAddr', '2')
              }
            })
          })
          wx.error(error => {
            // this.$store.commit('setRefuseAddr', '2')
            console.log(error)
          })
        })
      },
      getProvince (location) {
        this.$axios
          .get('netusers/get-province', {params: {location: location}})
          .then(res => {
            this.$store.commit('setProvince', res.data.data.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>
<style lang="scss">
  body {
    background-color: #fff !important;
  }

  .isIos {
    cursor: pointer;
  }
  .bold_{
    font-weight: bold;
  }
  .picker-items{width:100%}
  .flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
}

.flex-start {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
}

.flex-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	flex-wrap: wrap;
}

.flex-colum {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.flex-colum-start {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
}

.flex-colum-end {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-end;
}

.flex-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
}

.flex-around {
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue